module.exports = __webpack_public_path__ + "static/media/zehnder.d5d54c7d.jpg";